// reqres.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { Observable, catchError, delay, finalize, throwError } from 'rxjs';
import { ToastService } from '../services/toastr.service';
import { LoaderService } from '../services/loader.service';
import { SecureStorageService } from '../services/secure-storage.service';

export const reqResInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {

  const loaderService = inject(LoaderService);
  const secureStorage = inject(SecureStorageService);
  const toastService = inject(ToastService);
  const router = inject(Router);
  const token = secureStorage.getStorage('token') || ''

  const customDelay = req.headers.get('X-Delay');
  const delayTime = customDelay ? parseInt(customDelay) : 300;

  const skipLoaderEndpoints = [
    '/api/score',
    '/api/match',
    '/api/match/addExtraTime',
    '/api/score-match-by-id',
    '/api/drawsheet-master/update-match-result'
  ];

  const playerFormRoutes = [
    'player-add-form',
    'player-edit-form',
    'public-register',
    'coach-add-form',
    'coach-edit-form',
    'public-coach-register',
    'approval-list-form',
    'student-approval-form',
    'profile'
  ];
  const isPlayerForm = playerFormRoutes.some(route => router.url.includes(route));
  const isAddressApi = [
    '/api/master-country/getAllCountry',
    '/api/master-state/getStateByCountry',
    '/api/master-district/getDistrictByState',
    '/api/master-city/getCityByDistrict',
    '/api/master-country/getAllCountryForStudent',
    '/api/master-state/getStateByCountryForStudent',
    '/api/master-district/getDistrictByStateForStudent',
    '/api/master-city/getCityByDistrictForStudent'
  ].some(api => req.url.includes(api));

  const shouldSkipLoader = skipLoaderEndpoints.some(url => req.url.includes(url)) || (isPlayerForm && isAddressApi);

  if (!shouldSkipLoader) {
    loaderService.requestStarted();
  }

  let headers = req.headers.set('Authorization', `Bearer ${token}`);
  if (customDelay) {
    headers = headers.delete('X-Delay');
  }

  const cloned = req.clone({ headers });

  return next(cloned).pipe(
    delay(shouldSkipLoader ? 0 : delayTime),
    catchError((error) => {
      if (error.status === 401) {
        toastService.error('Unauthorized');
        sessionStorage.clear()
        router.navigate(['/login']);
      } else if (error.status === 403) {
        toastService.error('Forbidden');
        sessionStorage.clear()
        router.navigate(['/login']);
      } else if (error.status === 0) {
        toastService.error('Connection Refused: Please check if the server is running on port 3003', 'Network Error');
      } else if (error.status !== 404) {
        const errorMsg = error.error?.message || error.message || 'An unknown error occurred';
        toastService.error(errorMsg);
      }
      //  else {
      //   const errorMsg = error.error?.message || error.message || 'An unknown error occurred';
      //   toastr.error(errorMsg);
      // } 
      return throwError(() => error);
    }), finalize(() => {
      if (!shouldSkipLoader) {
        loaderService.requestEnded();
      }
    })
  );
};
